export default __webpack_public_path__ + "static/media/gasag_background_s1.e16d5780.jpg";